module.exports = __webpack_public_path__ + "img/zhaotong-67a54c.png";